import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'IS THIS A PHYSICAL OR DIGITAL PRODUCT?',
  answer: 'Football Ready is a 100% digital product delivered instantly in PDF format. You can access it from your laptop, tablet, or smartphone.'
}, {
  question: 'DO I NEED COACHING EXPERIENCE TO USE IT?',
  answer: 'No.\n\nThe system is designed for both beginner and experienced football coaches.'
}, {
  question: 'CAN I PRINT THE MATERIALS?',
  answer: 'Yes.\n\nYou can use everything digitally or print the resources for field use.'
}, {
  question: 'ARE THE BONUSES INCLUDED?',
  answer: 'Absolutely.\n\nAll 5 bonuses are included free with your purchase today.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-navy-950 border-t border-navy-800" data-id="element-41">
      <div className="container mx-auto px-4" data-id="element-42">
        <div className="text-center mb-16" data-id="element-43">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide" data-id="element-44">
            FREQUENTLY ASKED QUESTIONS
          </motion.h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-45">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-900 border border-navy-800 rounded-xl overflow-hidden" data-id="element-46">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-500" data-id="element-47">
                <span className="font-oswald text-xl text-white uppercase tracking-wide pr-8" data-id="element-48">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-gold-500 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-49" />
              </button>

              <AnimatePresence data-id="element-50">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-51">
                    <div className="px-6 pb-6 text-gray-400 whitespace-pre-line" data-id="element-52">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}